import { useId } from "react";

/**
 * Hook for generating accessibility IDs for form controls and their labels.
 * Centralizes ID generation logic and provides consistent naming patterns.
 *
 * @param prefix - Optional prefix for the generated ID (e.g., 'textarea', 'input')
 * @returns Object containing inputId and labelId for form control accessibility
 */
export const useAccessibilityId = (prefix?: string) => {
  const baseId = useId();
  const inputId = prefix ? `${prefix}-${baseId}` : baseId;
  const labelId = `${inputId}-label`;
  const helperTextId = `${inputId}-helper`;

  return {
    helperTextId,
    inputId,
    labelId,
  };
};
